import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Avatar } from "antd"
import { ArrowLeftOutlined, EditFilled } from "@ant-design/icons"
import _ from "../../utils/lodashUtils"
import { Button, TextTag as Text, CustomModal } from "../../atoms"
import { PageHeader } from "../../molecules/PageHeader"
import avatarRing from "../../assets/images/avatar-ring.svg"
import SpaceModal from "../../components/SpaceModal/SpaceModal"
import emptyProfileIcon from "../../assets/images/profile.svg"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"
import {
  EMAIL_LABEL,
  PHONE_LABEL,
  SPACE_NAME_LABEL,
  CONFIRMATION_CONTENT,
  REMOVE_PARTNER_TITLE,
  DEFAULT_SPACE_NAME,
  GET_ROBO_IMAGE,
  PARTNER_REMOVED,
  REMOVE_PARTNER_BUTTON,
  YES_REMOVE,
  BACK_BUTTON,
  PARTNER_NOT_MATCHED,
  PARTNER_LABEL,
  NO_BUTTON,
} from "../../constants/messages"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { rejectInvite } from "../../redux/actionCreators/invitePeople"
import history from "../../history"
import "./MyPartnerDetailsPage.scss"
import {
  ToastMessage,
  NOTIFICATION_TYPES,
} from "../../components/Notification/Notifications"
import {
  getPartnerNameorNickName,
  formatPhoneNumber,
} from "../../utils/helpers"
import { setPartnerOperation } from "../../redux/actionCreators/planDinnner"
import { date } from "yup"
import { ActivityIndicator } from "../../components/ActivityIndicator"

const returnPartnerDetails = (
  partner,
  chatSpaceName,
  displayName,
  partnerState,
  inviteType
) => {
  const profileImage = _.get(
    partnerState,
    "userDetails.profile_image",
    _.get(partner, "profile_image")
  )

  const formatedPhoneNumber = _.get(partner, "phone_number")
    ? formatPhoneNumber(_.get(partner, "phone_number"))
    : formatPhoneNumber(_.get(partner, "partner2_identifier"))

  return (
    <div id="profilePage">
      <div className="profile-image">
        <div className="display-img">
          <div className="avatar">
            <img className="ovalBg" src={avatarRing} alt="backgroud circle" />
            {!_.isEmpty(profileImage) ? (
              <Avatar id="uploadAvatar" size={100} src={profileImage} />
            ) : (
              <div>
                {partner && displayName ? (
                  <Avatar
                    id="uploadAvatar"
                    size={100}
                    src={GET_ROBO_IMAGE(displayName)}
                  />
                ) : (
                  <Avatar id="uploadAvatar" size={100} src={emptyProfileIcon} />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="display-name">
          <Text textType="pageHeading"> {displayName} </Text> <EditFilled />
        </div>
      </div>
      <div className="partner-detail">
        <div className="flex-row">
          <Text>{EMAIL_LABEL}</Text>{" "}
          <Text className="name-space">
            {_.get(partner, "email")
              ? _.get(partner, "email")
              : inviteType === "Email" ||
                _.get(partner, "invite_type") === "Email"
              ? _.get(partner, "partner2_identifier", "")
              : ""}
          </Text>
        </div>
        <div className="flex-row">
          <Text>{PHONE_LABEL}</Text>{" "}
          <Text className="name-space">
            {formatedPhoneNumber && formatedPhoneNumber.intlCode
              ? `${formatedPhoneNumber.intlCode} ${formatedPhoneNumber.telephoneNumber}`
              : _.get(partner, "phone_number", "")}
          </Text>
        </div>
        <div className=" flex-row space-name">
          <Text>{SPACE_NAME_LABEL}</Text>{" "}
          <div className="space-edit">
            <Text className="name-space">
              {chatSpaceName ? chatSpaceName : DEFAULT_SPACE_NAME}
            </Text>
            <SpaceModal
              buttonType={"link"}
              onSubmit={() => {}}
              chatSpaceName={chatSpaceName}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const MyPartnerDetailsPage = ({
  partners,
  partner,
  rejectInvite,
  user,
  fetchPartnerDetails,
  invitePeople,
  partnerOperationLoading,
  setPartnerOperation,
}) => {
  const goBackHandle = () => {
    history.push("/dashboard")
  }
  const { dateState, partnerState } = React.useContext(FirebaseContext)
  const [showRemovePartnerModal, setRemovePartnerModal] = React.useState(false)
  const displayName = getPartnerNameorNickName(partnerState, partner, partners)

  const chatSpaceName = _.get(
    dateState,
    "chatSpaceName",
    _.get(partners, "chat_space_name", "")
  )
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )
  const inviteType = _.get(invitePeople, "invite_type")

  useEffect(() => {
    fetchPartnerDetails()
  }, [])
  const restaurantId = acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
  const removePartner = () => {
    setRemovePartnerModal(true)
  }

  return (
    <div id="MyPartner">
      <div className="wrapper">
        <div className="backBtn">
          <PageHeader
            onClick={goBackHandle}
            btnText={BACK_BUTTON}
            icon={<ArrowLeftOutlined />}
            headerText={PARTNER_LABEL}
          />
        </div>
        {!_.isEmpty(partner) &&
        _.get(partners, "dating_status") === "ACTIVE" ? (
          returnPartnerDetails(
            partner,
            chatSpaceName,
            displayName,
            partnerState,
            inviteType
          )
        ) : (
          <div className="container">
            {_.isEmpty(partner) &&
            !_.isEmpty(partners) &&
            _.get(partners, "dating_status") === "INACTIVE" &&
            _.get(dateState, "status") !== "REJECTED" ? (
              returnPartnerDetails(
                partners,
                chatSpaceName,
                displayName,
                partnerState,
                inviteType
              )
            ) : (
              <div className="no-partner">
                <Text textType="bodyHeading">{PARTNER_NOT_MATCHED}</Text>
              </div>
            )}
          </div>
        )}
        {/* Show when 
        1. user invites partner:: to user , but not to partner
        2. partner accepts invite:: to both user and partner */}
        {((_.isEmpty(partner) &&
          _.get(partners, "dating_status") === "INACTIVE") ||
          _.get(dateState, "status") === "ACTIVE") &&
          _.get(dateState, "status") !== "REJECTED" && (
            <div className="remove-partner">
              <Button
                className="remove-btn gradient-purple"
                btnType="colorBorder"
                btnSize="large"
                onClick={removePartner}
              >
                {REMOVE_PARTNER_BUTTON}
              </Button>
            </div>
          )}
      </div>
      <CustomModal
        title={REMOVE_PARTNER_TITLE}
        visible={showRemovePartnerModal}
        keyboard={false}
        destroyOnClose={true}
        footer={[
          <Button
            className="center-loader-position"
            onClick={async () => {
              const name = getPartnerNameorNickName(
                partnerState,
                partner,
                partners
              )
              ToastMessage({
                type: NOTIFICATION_TYPES.SUCCESS,
                message: PARTNER_REMOVED(name),
              })
              setPartnerOperation(true)
              //redirect partner
              await FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.ACTIVE_ROUTE]: "/dashboard",
                },
                `${FirebaseService.getDefaultPath()}${partner.uuid}/`
              )
              //redirect user
              await FirebaseService.setActiveRoute("/dashboard")
              await FirebaseService.setInviteStatus("REJECTED")
              await FirebaseService.patch(
                {
                  [FIREBASE_STATE_KEYS.REJECTED_BY]: user.uuid,
                },
                `${FirebaseService.getDefaultPath()}`
              )
              await rejectInvite(restaurantId)
              setRemovePartnerModal(false)
              setPartnerOperation(false)
              history.push("/dashboard")
            }}
          >
            {partnerOperationLoading && <ActivityIndicator />}
            {YES_REMOVE}
          </Button>,
          <Button
            key="cancel"
            btnType="bordered"
            onClick={() => setRemovePartnerModal(false)}
          >
            {NO_BUTTON}
          </Button>,
        ]}
      >
        <Text>{CONFIRMATION_CONTENT}</Text>
      </CustomModal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.auth.user,
  partners: _.get(state.invitePeople, "partnerDetails"),
  partner: _.get(state.auth, "partner"),
  invitePeople: _.get(state, "invitePeople"),
  partnerOperationLoading: _.get(state, "loadingState.partnerOperationLoading"),
})

export default connect(mapStateToProps, {
  rejectInvite,
  fetchPartnerDetails,
  setPartnerOperation,
})(withRouter(MyPartnerDetailsPage))
